import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { useState as d, useRef as b, useEffect as m } from "react";
import { classes as i } from "../../utils/helpers.js";
import { blockLayoutsMap as h } from "../../settings.js";
import { C as k } from "../../chevron-left-DJljp5g6.mjs";
import '../../assets/InfoPanel.css';const v = "_fade_1j4w6_1", s = {
  "info-panel": "_info-panel_1j4w6_1",
  fade: v,
  "info-panel__back-btn": "_info-panel__back-btn_1j4w6_19"
};
function N({
  layoutComponent: e = { layout: "", props: {} },
  onBackClicked: l = () => {
  },
  backButtonLabel: c = "Back to List",
  classname: y = ""
}) {
  const [f, L] = d(null), [t, u] = d("entering"), n = b(null), p = b(null), _ = (a) => {
    p.current = a, u("exiting"), n.current.scrollTo({
      top: n.current.offsetTop,
      left: 0,
      behaviour: "instant"
    });
  };
  return m(() => {
    async function a() {
      L(h.get(e.layout));
    }
    a();
  }, [e.layout]), m(() => {
    n.current !== null && (t === "exiting" && n.current.addEventListener("animationend", () => {
      l(p.current);
    }, { once: !0 }), t === "entering" && n.current.addEventListener("animationend", () => {
      u("idle");
    }, { once: !0 }));
  }, [t, l]), /* @__PURE__ */ o("div", { className: i([s["info-panel"], `${y}`]), "data-state": t, ref: n, children: [
    /* @__PURE__ */ o(
      "button",
      {
        className: i([s["info-panel__back-btn"], "info-panel__back-btn"]),
        type: "button",
        onClick: _,
        children: [
          /* @__PURE__ */ r(k, {}),
          c
        ]
      }
    ),
    f !== null && /* @__PURE__ */ r(f, { ...e.props }),
    /* @__PURE__ */ o(
      "button",
      {
        className: i([s["info-panel__back-btn"], "info-panel__back-btn"]),
        type: "button",
        onClick: _,
        children: [
          /* @__PURE__ */ r(k, {}),
          c
        ]
      }
    )
  ] });
}
export {
  N as InfoPanel,
  N as default
};
